/*Dev Environment we need to import the below modules*/
//import { sp as sppnp } from '@pnp/sp';
//import { SPFetchClient } from "@pnp/nodejs";
/*End of Dev setup*/

/* PROD Environment we need to import the below modules*/
//import { sp, SPRequestExecutorClient, setup } from "sp-pnp-js";

import * as $ from "jquery";
//Remdiation changes
import { spfi, SPBrowser, spGet, SPQueryable } from "@pnp/sp";
import { AssignFrom, TimelinePipe } from "@pnp/core";
import { MSAL, getMSAL, MSALOptions } from "@pnp/msaljsclient";
import "@pnp/sp/webs";
import "@pnp/sp/site-users/web";
import "@pnp/sp/search";
import "@pnp/sp/files";
import "@pnp/sp/fields";
import "@pnp/sp/folders";
import "@pnp/sp/attachments";

import { SearchQueryBuilder, SearchResults, ISearchQuery } from "@pnp/sp/search";

//import { AdalFetchClient } from "@pnp/nodejs";
/*End of PROD setup*/

/*URL Setup for Dev*/
// Set URL globally
const url = "https://shelldevelopment.sharepoint.com/sites/SPODA0019/CSO";
/*End of URL Setup for Dev*/

/*PROD URL Setup*/
//let appweburl;
//let hostweburl;
//let sitecollectionurl;
//let siteSiteAssetsURL;
/*End of URL Setup for PROD*/
//let location = useLocation();
// Helpers util for all the calls    
const helpers = {

    // Get data based on preference (All data, Specific columns, Expanded clumns)
    // For all columns, last two parameters are optional and not required
    // For specific columns, 3rd parameter is required to be passed as array of strings (refer to banner.tsx)
    // Pass a callback function as the 2nd parameter to process the data after being fetched from list
    // For expanded columns, 3rd and 4th parameters need to be passed as per requirement, 4th column is the array of strings with names of columns which have to be expanded
    // Refer to banner.tsx for detailed understanding  

    /*Starting of Pre-Prod URL*/
    //sitecollectionurl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //    "https://eu023-sp.shell.com/sites/SPOAA0668/" :
    //    "https://eu023-sp.shell.com/sites/SPOAA0668/",
    //appweburl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //    "https://eu023-sp.shell.com/sites/SPOAA0668/" :
    //    "https://eu023-sp.shell.com/sites/SPOAA0668/",
    //hostweburl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //    "https://eu023-sp.shell.com/sites/SPOAA0668/" + window.location.hash.split("/")[1] :
    //    "https://eu023-sp.shell.com/sites/SPOAA0668/" + window.location.hash.split("/")[1],
    //siteSiteAssetsURL: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //    "/sites/SPOAA0668/" + window.location.hash.split("/")[1] + "/SiteAssets" :
    //    "/sites/SPOAA0668/" + window.location.hash.split("/")[1] + "/SiteAssets",
    //    siteCalanderURL: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //    "/sites/SPOAA0668/" + window.location.hash.split("/")[1] + "/Calendar" :
    //    "/sites/SPOAA0668/" + window.location.hash.split("/")[1] + "/Calendar",
    //siteOrigin: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //    "https://eu023-sp.shell.com" :
    //    "https://eu023-sp.shell.com",
    //siteAppSearchURL: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //    "https://eu023-sp.shell.com" :
    //    "https://eu001-sp.shell.com",
    //krDocURL: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //    "https://eu023-sp.shell.com" :
    //    "https://eu001-sp.shell.com/sites/AAAAB2112/",
    //taxonomyURLAppWebURL: "https://eu023-sp.shell.com/sites/SPOAA0668/",
    //taxonomyURL: "/sites/SPOAA0668/TaxonomyTerms/taxonomy.txt",
    ////appinsightsinstrumentationKey: "7ca2c8fc-91e2-4ba0-a164-37751d079dc1",
    //appinsightsinstrumentationKey: "8faf6b39-49d3-45d5-98cc-62474d3d5f4a",
    //rootSiteCollection: "https://eu023-sp.shell.com/sites",
    //EESiteCollectionUrl: "https://eu023-sp.shell.com/sites/SPOAA0041",
    //spoAHomePageURL: "https://eu023-sp.shell.com/sites/SPOAA0027/default.aspx",

    /*End of Pre-Prod URL*/

    /*Starting of UAT URL*/
    //sitecollectionurl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //   "https://eu023-sp.shell.com/sites/spoaa0027/" :
    //   "https://eu023-sp.shell.com/sites/spoaa0027/",
    //appweburl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //   "https://eu023-sp.shell.com/sites/spoaa0027/" :
    //   "https://eu023-sp.shell.com/sites/spoaa0027/",
    //hostweburl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //   "https://eu023-sp.shell.com/sites/spoaa0027/" + window.location.hash.split("/")[1] :
    //   "https://eu023-sp.shell.com/sites/spoaa0027/" + window.location.hash.split("/")[1],
    //sitesiteassetsurl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //   "/sites/spoaa0027/" + window.location.hash.split("/")[1] + "/siteassets" :
    //   "/sites/spoaa0027/" + window.location.hash.split("/")[1] + "/siteassets",
    //sitecalanderurl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //   "/sites/spoaa0027/" + window.location.hash.split("/")[1] + "/calendar" :
    //   "/sites/spoaa0027/" + window.location.hash.split("/")[1] + "/calendar",
    //siteorigin: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //   "https://eu023-sp.shell.com" :
    //   "https://eu023-sp.shell.com",
    //siteappsearchurl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //   "https://eu023-sp.shell.com" :
    //   "https://eu023-sp.shell.com",
    //krdocurl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
    //   "https://eu001-sp.shell.com/sites/aaaab2112/" :
    //   "https://eu001-sp.shell.com/sites/aaaab2112/",
    //taxonomyurlappweburl: "https://eu023-sp.shell.com/sites/spoaa0027/",
    //taxonomyurl: "/sites/spoaa0027/taxonomyterms/taxonomy.txt",
    //appinsightsinstrumentationKey: "8faf6b39-49d3-45d5-98cc-62474d3d5f4a",
    //rootSiteCollection: "https://eu023-sp.shell.com/sites",
    //EESiteCollectionUrl:"https://eu023-sp.shell.com/sites/spoaa0041",
    //spoAHomePageURL:"https://eu023-sp.shell.com/sites/spoaa0027/default.aspx",

    /*End of UAT URL*/

    /*Starting of PROD URL*/
     sitecollectionurl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
        "https://eu001-sp.shell.com/sites/AAAAA9133/" :
         "https://eu001-sp.shell.com/sites/AAAAA9133/",
     appweburl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
         "https://eu001-sp.shell.com/sites/AAAAA9133/" :
         "https://eu001-sp.shell.com/sites/AAAAA9133/",
     hostweburl: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
         "https://eu001-sp.shell.com/sites/AAAAA9133/" + window.location.hash.split("/")[1] :
         "https://eu001-sp.shell.com/sites/AAAAA9133/" + window.location.hash.split("/")[1],
     siteSiteAssetsURL: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
         "/sites/AAAAA9133/" + window.location.hash.split("/")[1] + "/SiteAssets" :
         "/sites/AAAAA9133/" + window.location.hash.split("/")[1] + "/SiteAssets",
     siteCalanderURL: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
         "/sites/AAAAA9133/" + window.location.hash.split("/")[1] + "/Calendar" :
         "/sites/AAAAA9133/" + window.location.hash.split("/")[1] + "/Calendar",
     siteOrigin: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
         "https://eu001-sp.shell.com" :
         "https://eu001-sp.shell.com",
     siteAppSearchURL: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
         "https://eu001-sp.shell.com" :
         "https://eu001-sp.shell.com",
     krDocURL: window.location.href.toLowerCase().indexOf('localhost') !== -1 ?
         "https://eu001-sp.shell.com/sites/AAAAB2112/" :
         "https://eu001-sp.shell.com/sites/AAAAB2112/",
     taxonomyURLAppWebURL: "https://eu001-sp.shell.com/sites/AAAAA9133/",
     taxonomyURL: "/sites/AAAAA9133/TaxonomyTerms/taxonomy.txt",
     ////appinsightsinstrumentationKey: "911b7671-75a1-40e9-9974-43901ad40b7c",
     appinsightsinstrumentationKey: "57570c1d-f544-45ab-b8c7-adfc79144c31",
     rootSiteCollection: "https://eu001-sp.shell.com/sites",
     EESiteCollectionUrl:"https://eu001-sp.shell.com/sites/AAAAB1732",
     spoAHomePageURL:"https://eu001-sp.shell.com/sites/AAAAA9133/default.aspx",

    /*End of PROD URL*/


    callRestApi: function (weburl: string, querytext: string, _callbackSuccess: any, _callbackFailure: any) {

        const spQueryable = SPQueryable(weburl + "/_api/search/query?querytext=" + querytext).using(AssignFrom(window['SP_Propertyweb']));

        // and then use spQueryable to make the request
        spGet(spQueryable).then((response: any) => {
            console.log(response);
            _callbackSuccess(response);
        }).catch((error: any) => {
            console.error(error);
            //_callbackFailure(error);
        });
    },

     callRestApiwithoutcallback: async function (weburl: string, querytext: string) {

        const spQueryable = SPQueryable(weburl + "/_api/search/query?querytext=" + querytext).using(AssignFrom(window['SP_Propertyweb']));
        // and then use spQueryable to make the request
        let response = await spGet(spQueryable);
        return response;
    },

    getAllData: function (listName: string, _callback: any, columns?: any, expandCol?: any, order?: any, filters?: any, top?: any): any {

        if (top === undefined) {
            top = "";
        }
        if (filters === undefined) {
            filters = "";
        }
        if (order === undefined) {
            order = "Id";
        }
        if (window['SP_Propertyweb'] == undefined) {
            helpers.authenticateUser(msalService, () => {
                window['SP_Propertyweb'].lists.getByTitle(listName).items.select(columns).expand(expandCol).orderBy(order).filter(filters).top(4999)().then((items: any[]) => {
                    _callback(items);
                }).catch(e => {
                    UserAutheticateCall();
                });
            }, "");
        }
        else {
            window['SP_Propertyweb'].lists.getByTitle(listName).items.select(columns).expand(expandCol).orderBy(order).filter(filters).top(4999)().then((items: any[]) => {
                _callback(items);
            }).catch(e => {
                UserAutheticateCall();
            });
        }

    },



    getUser: function (_callback: any): any {
        window['SP_Propertyweb'].currentUser().then((r: any) => {
            _callback(r);
        }).catch(e => {
            UserAutheticateCall();
        });
    },

    getUserGroupdetails: function (Id: string, _callback: any): any {
        window['SP_Propertyweb'].getUserById(parseInt(Id, 10)).groups().then((r: any) => {
            _callback(r);
        }).catch(e => {
            UserAutheticateCall();
        });
    },
    getAllDatasortdesc: function (listName: string, _callback: any, columns?: any, expandCol?: any, order?: any, filters?: any, top?: any): any {

        if (top === undefined) {
            top = "";
        }
        if (filters === undefined) {
            filters = "";
        }
        if (order === undefined) {
            order = "Id";
        }

        window['SP_Propertyweb'].lists.getByTitle(listName).items.select(columns).expand(expandCol).orderBy(order, false).filter(filters).top(top)().then((items: any[]) => {
            _callback(items);
        }).catch(e => {
            UserAutheticateCall();
        });
    },

    getUserNames: function (_callback: any, name: string) {
        window['SP_Propertyweb'].siteUsers.top(499).filter("substringof('" + name + "',Title)")().then(function (data) {
            _callback(data);
        }).catch(e => {
            UserAutheticateCall();
        });
    },

    getWebEnsureUser: function (_callback: any, name: string) {
        window['SP_Propertyweb'].ensureUser(name).then(function (data) {
            _callback(data);
        }).catch(e => {
            UserAutheticateCall();
        });
    },
    getsearchResults: function (queryText: any, selectProperties: string, sourceId: string, rowLimit: any, _callback: any, _errorCallback: any) {

        let searchQuery = SearchQueryBuilder().text(queryText).rowLimit(rowLimit);
        if (selectProperties) {
            searchQuery.selectProperties(selectProperties);
        }
        if (sourceId != null) {
            searchQuery.sourceId(sourceId);
        }
        searchQuery.trimDuplicates.clientType("ContentSearchRegular");

        window['SP_PropertySearch'].search(searchQuery)
            .then(function (results) {
                console.log("Search results:", results.PrimarySearchResults);
                _callback(results); // Call your success handler
            })
            .catch(function (error) {
                console.error("Error executing search query:", error);
                _errorCallback(error); // Call your error handler
            });

    },

    getAllDataSorted: function (listName: string, _callback: any, columns?: any, expandCol?: any, filterCol?: any, orderbyCol?: any): any {
        let anyData: any[] = [];
        if (filterCol === undefined) {
            filterCol = ""
        }
        //get items
        window['SP_Propertyweb'].lists.getByTitle(listName).items.select(columns).expand(expandCol).filter(filterCol).orderBy(orderbyCol)().then((items: any[]) => {
            _callback(items);
        }).catch(e => {
            UserAutheticateCall();
        });
    },

    updateData: function (listName: string, data: any, id: string, _callback?: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.getById(parseInt(id, 10)).update(
            data
        ).then(i => {
            _callback();
        }).catch(e => {
            UserAutheticateCall();
        });
    },

    deletelinks: function (listName: string, _callback: any, ID?: any,): any {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.getById(ID).recycle().then(_ => { _callback() }).catch(e => {
            UserAutheticateCall();
        });
    },
    deleteItemByID: function (listName: string, ID?: any, _callback?: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.getById(ID).recycle().then((iar: any) => {
            _callback(iar);
        }).catch(e => {
            UserAutheticateCall();
        });
    },
    getAllChoices: function (listName: string, fieldName: string, _callback?: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).fields.getByInternalNameOrTitle(fieldName)().then(function (f) {
            _callback(f.Choices);
        }).catch(e => {
            UserAutheticateCall();
        });
    },
    addData: function (listName: string, data: any, _callback?: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.add(data).then((iar: any) => {
            _callback(iar);
        }).catch(e => {
            UserAutheticateCall();
        });
    },
    deleteCustomExpert: function (listName: string, ID?: any, _callback?: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.getById(ID).delete().then((iar: any) => {
            _callback(iar);
        }).catch(e => {
            UserAutheticateCall();
        });
    },
    updateCustomExpert: function (listName: string, data: any, ID: any, _callback: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.getById(ID).update(data).then((iar: any) => {
            _callback(iar);
        }).catch(e => {
            UserAutheticateCall();
        });
    },
    getSearchresult: function (listName: string, _callback?: any, columns?: any, filterCol?: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.select(columns).filter(filterCol)().then((items: any[]) => {
            _callback(items);
        }).catch(e => {
            UserAutheticateCall();
        });
    },

    //New Methods Amar
    getAllDataSortedNew: function (listName: string, _callback: any, _failureCallback: any, columns?: any, expandCol?: any, filterCol?: any, orderbyCol?: any, top?: any): any {

        let query: any = null;

        //get items
        if (window['SP_Propertyweb'] == undefined) {
            helpers.authenticateUser(msalService, () => {
                query = window['SP_Propertyweb'].lists.getByTitle(listName).items;
                if (columns) {
                    query = query.select(columns);
                }
                if (expandCol) {
                    query = query.expand(expandCol);
                }
                if (filterCol) {
                    query = query.filter(filterCol);
                }
                if (orderbyCol && orderbyCol.length > 0) {
                    orderbyCol.forEach((val, key) => {
                        query = query.orderBy(val.field, val.order);
                    });
                }
                if (top) {
                    query = query.top(top);
                }
                query().then((items: any[]) => {
                    _callback(items);
                }).catch(e => {
                    _failureCallback(e);
                    UserAutheticateCall();
                });
            }, "");
        }
        else {
            query = window['SP_Propertyweb'].lists.getByTitle(listName).items;
            if (columns) {
                query = query.select(columns);
            }
            if (expandCol) {
                query = query.expand(expandCol);
            }
            if (filterCol) {
                query = query.filter(filterCol);
            }
            if (orderbyCol && orderbyCol.length > 0) {
                orderbyCol.forEach((val, key) => {
                    query = query.orderBy(val.field, val.order);
                });
            }
            if (top) {
                query = query.top(top);
            }
            query().then((items: any[]) => {
                _callback(items);
            }).catch(e => {
                _failureCallback(e);
                UserAutheticateCall();
            });
        }


    },

    getAllDataSortedWithoutCallback: function (listName: string, columns?: any, expandCol?: any, filterCol?: any, orderbyCol?: any, top?: any): any {

        //get items
        let query = window['SP_Propertyweb'].lists.getByTitle(listName).items;
        if (columns) {
            query = query.select(columns);
        }
        if (expandCol) {
            query = query.expand(expandCol);
        }
        if (filterCol) {
            query = query.filter(filterCol);
        }
        if (orderbyCol && orderbyCol.length > 0) {
            orderbyCol.forEach((val, key) => {
                query = query.orderBy(val.field, val.order);
            });
        }
        if (top) {
            query = query.top(top);
        }
        return query();
        // query().then((items: any[]) => {
        //     return items;
        // }).catch(e => {
        //     return null;
        // });
    },
    addItem: function (listName: string, data: any, _callbackSuccess?: any, _callbackFailure?: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.add(data).then((iar: any) => {
            _callbackSuccess(iar);
        }).catch(e => {
            _callbackFailure(e)
        });
    },
    deleteItem: function (listName: string, ID?: any, _callbackSuccess?: any, _callbackFailure?: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.getById(ID).delete().then((iar: any) => {
            _callbackSuccess(iar);
        }).catch(e => {
            _callbackFailure(e);
        });
    },
    updateItem: function (listName: string, data: any, ID: any, _callbackSuccess?: any, _callbackFailure?: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.getById(ID).update(data).then((iar: any) => {
            _callbackSuccess(iar);
        }).catch(e => {
            _callbackFailure(e);
        });
    },
    recycleItem: function (listName: string, data: any, ID: any, _callbackSuccess?: any, _callbackFailure?: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.getById(ID).recycle().then((iar: any) => {
            _callbackSuccess(iar);
        }).catch(e => {
            _callbackFailure(e);
        });
    },
    getAllDataSortedRoot: function (listName: string, _callback: any, _failureCallback: any, columns?: any, expandCol?: any, filterCol?: any, orderbyCol?: any, top?: any): any {

        //get items
        let query = window['SP_PropertyRootWeb'].lists.getByTitle(listName).items;
        if (columns) {
            query = query.select(columns);
        }
        if (expandCol) {
            query = query.expand(expandCol);
        }
        if (filterCol) {
            query = query.filter(filterCol);
        }
        if (orderbyCol && orderbyCol.length > 0) {
            orderbyCol.forEach((val, key) => {
                query = query.orderBy(val.field, val.order);
            });
        }
        if (top) {
            query = query.top(top);
        }
        query().then((items: any[]) => {
            _callback(items);
        }).catch(e => {
            _failureCallback(e);
            UserAutheticateCall();
        });
    },
    getKRListView: function (listName: string, _callback?: any, columns?: any, filterCol?: any) {
        window['SP_Propertyweb'].lists.getByTitle(listName).items.select(columns).filter(filterCol)().then((items: any[]) => {
            _callback(items);
        }).catch(e => {
            UserAutheticateCall();
        });
    },
    getFileBuffer: function (serverRelativeUrl: string, _callbackSuccess?: any, _callbackFailure?: any, isRootWeb?: any) {
        let spWeb = isRootWeb ? window['SP_PropertyRootWeb'] : window['SP_Propertyweb'];
        spWeb.getFileByServerRelativePath(serverRelativeUrl).getBuffer().then((buffer: any) => {
            _callbackSuccess(buffer);
        }).catch(e => {
            _callbackFailure(e);
        });
    },
    uploadFile: function (folderServerRelativeUrl: string, fileName: string, file: any, _callbackSuccess?: any, _callbackFailure?: any) {
        window['SP_Propertyweb'].getFolderByServerRelativePath(folderServerRelativeUrl).files.addChunked(fileName, file, { Overwrite: true }).then((data: any) => {
            _callbackSuccess(data);
        }).catch(e => {
            _callbackFailure(e);
        });
    },
    uploadonItemAddFile: function (listName: string, ID : any, fileName: string, file: any, _callbackSuccess?: any, _callbackFailure?: any) {

        window['SP_Propertyweb'].lists.getByTitle(listName).items.getById(ID).attachmentFiles.add(fileName, file).then((data: any) => {
            _callbackSuccess(data);
        }).catch(e => {
            _callbackFailure(e);
        });
    },
    getFileContent: function (serverRelativeUrl: string, _callbackSuccess?: any, _callbackFailure?: any, isRootWeb?: any) {
        let spWeb = isRootWeb ? window['SP_PropertyRootWeb'] : window['SP_Propertyweb'];
        spWeb.getFileByServerRelativePath(serverRelativeUrl).getText().then((content: any) => {
            _callbackSuccess(content);
        }).catch(e => {
            _callbackFailure(e);
        });
    },

    createMarkup: function (value: any) {
        return { __html: value };
    },
    searchCallBacks: {
        ON_CONLCUDED_DISCUSSIONS: "onConcludedDiscussions",
        ON_FORUM_NAME: "onForumName",
        ON_PRACTICE_WORTH_REPLICATING: "onPracticeWorthReplicating",
        ON_LESSONS_LEARNED: "onLessonsLearned",
        ON_LEARNING_FROM_INCIDENT: "onLearningFromIncident",
        ON_LEARNING_EXPERT_APPROVED: "onLearningExpertApproved",
        ON_LEARNING_SUBMITTED: "onLearningSubmitted",
        ON_ARTICLE_EXPERT_APPROVED: "onArticleExpertApproved",
        ON_ARTICLE_PEER_REVIEWED: "onArticlePeerReviewed",
        ON_ARTICLE_USER_CONTRIBUTED: "onArticleUserContributed",
        ON_SPOA_ANNOUNCEMENTS: "onSPoAAnnouncements",
        ON_SPOA_LEADERSHIPTEAM: "onSPoALeadershipTeam",
        ON_SPOA_LINKS: "onSPoALinks",
        ON_SPOA_EVENTS: "onSPoAEvents"

    },

    authenticateUser: function (instance, _callbackSuccess: any, _callbackFailure: any): boolean {
        let isAuthenticated = false;
        try {
            msalService = instance;
            let accounts = instance.getAllAccounts();
            if (accounts.length > 0) {
                let hostUrl= helpers.sitecollectionurl + window.location.hash.split("/")[1];  
                helpers.hostweburl=hostUrl;              
                const sp = spfi(hostUrl).using(SPBrowser(), GetMSALTokenForPNP());
                const rootSP = spfi(helpers.sitecollectionurl).using(SPBrowser(), GetMSALTokenForPNP());
                window['SP_PropertySearch'] = sp;
                window['SP_Propertyweb'] = sp.web;
                window['SP_PropertyRootWeb'] = rootSP.web;
            }
            else {
                console.log("No accounts found, please login again.");
                instance.initialize();
            }
        }
        catch (exception) {
            console.log("Error in authenticateUser: " + exception);
            throw exception;
            isAuthenticated = false;
        }
        return isAuthenticated;
    },
}
const SPloginRequest = {
    scopes: ["https://ShellCorp.sharepoint.com/.default"]
};
let msalService: any;
function GetMSALTokenForPNP(): TimelinePipe<any> {
    return (instance: any) => {
        instance.on.pre(async (url, init, result) => {
            const scopes = {
                scopes: ["https://ShellCorp.sharepoint.com/.default"]
            };
            const account = msalService.getAllAccounts()[0];
            SPloginRequest["account"] = account;
            let token = '';

            token = await msalService
                .acquireTokenSilent(SPloginRequest);

            init.headers = { ...init.headers, authorization: `Bearer ${token["accessToken"]}` };

            return [url, init, result];
        });

        return instance;
    };
}

function UserAutheticateCall() {
    let ErrorPopup = document.getElementsByClassName("ms-subtleEmphasis");
    if (ErrorPopup.length == 1) {
        //$('.ms-subtleEmphasis').hide();
        var redi = window.location.href;
        redi = redi.replace(/#/g, 'hash');
        window.location.href = helpers.sitecollectionurl + 'Pages/Redirect.aspx?targetUrl=' + redi;
    }
}

export default helpers;
